<template>
    <div class="xeHorizontalBar heightMAX rounded" :class="{ 'is-overview-compact': isOverviewCompact }" style="overflow: hidden">
        <div class="heightMAX" style="padding: 0">
            <drop @dragover="handleBodyDragOver(...arguments)" @drop="handleBodyDrop(...arguments)"
                class="heightMAX kbet-custom-reset">
                <div class="rounded kbet-widget-energy heightMAX" style="display: block">
                    <div class="title rounded-top">
                        {{ titleSplit }}
                        <div v-if="!isSinglePage" class="right-controls-usage">
                            <div class="right-controls">
                                <span class="carousel-control">
                                    <i @click="goToPrev" class="fas fa-angle-left arrow"></i>
                                    <i @click="goToNext" class="fas fa-angle-right arrow"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="chartHeightMax heightImportant">
                        <div class="align-card-content">
                            <b-carousel ref="carousel" v-if="progressData.length > 0" :key="progressData.length"
                                :interval="5000" :controls="false" :no-wrap="false" class="horizontal-carousel">
                                <b-carousel-slide v-for="(chunk, chunkIndex) in groupedData" :key="chunkIndex"
                                    class="progress-slide">
                                    <div class="progress-container" :style="{ gap: computedGap }">
                                        <div v-for="(item, index) in chunk" :key="`${chunkIndex}-${index}`">
                                            <ProgressBar :item="item" :itemColors="itemColors"
                                                :showPrevData="showPrevData"
                                                :unit="item.displayUnit || item.originalUnit || ''"
                                                :cardHeight="cardHeight" :usageData="progressData"
                                                :compact="isOverviewCompact" ref="progressBar" />
                                        </div>
                                    </div>
                                </b-carousel-slide>
                            </b-carousel>
                        </div>
                    </div>
                </div>
            </drop>
        </div>

        <b-modal ref="modalSetting" size="lg" :title="`${$t('설정')} - Horizontal Bar ${$t('차트')}`"
            bodyClass="p-t-0 p-b-0" hide-footer>
            <chart-horizontal-bar-setting :initSetting="chartSetting" @on-modal-cancel="onModalCancel"
                @on-modal-ok="onModalOK" />
        </b-modal>
    </div>
</template>

<script>
import xeBaseWidget from "@src/views/widget/v1/common/xeBaseWidget.js";
import ProgressBar from "../../../components/vue-chartjs/Charts/ProgressBar.vue";
import chartHorizontalBarSetting from "./setting/xeHorizontalBarSetting.vue";
import utils from "@src/views/widget/v1/common/xeBaseUtils.js";
import xelib from "xelib";

const { Unit } = xelib.PointBoxV2;

export default {
    extends: xeBaseWidget,
    components: {
        ProgressBar,
        chartHorizontalBarSetting,
    },
    props: ["cardHeight"],
    data() {
        return {
            progressData: [],
            itemColors: {},
            showPrevData: { prevDay: false, prevYear: false },
            themeColor: global.xe.parseBool(localStorage.contentInverse)
                ? require("../../../components/vue-chartjs/Sample/ChartOptions/DashboardChartColor.json").dark
                : require("../../../components/vue-chartjs/Sample/ChartOptions/DashboardChartColor.json").light,
        };
    },
    computed: {
        isSinglePage() {
            return this.groupedData.length <= 1;
        },
        titleSplit() {
            let result = this.widget.title;
            let splitTitle = "";
            let titleUnit = "";
            if (result.includes("(") || result.includes(")")) {
                splitTitle = result.split("(");
                titleUnit = `(${splitTitle[1].split(")")[0]})`;
                result = `${global.xe.$t(splitTitle[0])} ${titleUnit}`;
            } else {
                result = global.xe.$t(result);
            }
            return result;
        },
        chartSetting() {
            return JSON.parse(JSON.stringify(this.widget));
        },
        computedGap() {
            if (this.isOverviewCompact) {
                if (this.cardHeight <= 5) return "4px";
                if (this.cardHeight <= 10) return "8px";
                return "12px";
            }
            if (this.cardHeight <= 5) return "10px";
            if (this.cardHeight <= 10) return "20px";
            return "35px";
        },
        limitProgressCount() {
            if (this.cardHeight <= 5) {
                return 3;
            } else if (this.cardHeight <= 10) {
                return 6;
            } else {
                return 10;
            }
        },
        groupedData() {
            const out = [];
            for (let i = 0; i < this.progressData.length; i += this.limitProgressCount) {
                out.push(this.progressData.slice(i, i + this.limitProgressCount));
            }
            return out;
        },
    },
    created() {
        // 기본 설정
        if (!this.widget.series) this.widget.series = [{ label: "Default", point: "", backgroundColor: "#348fe2" }];
        if (!this.widget.addition)
            this.widget.addition = {
                xAxes: { label: "", min: 0, max: 0, stacked: false, unit: "" },
                afterAction: "",
                fixed: 0,
            };
        if (!this.widget.self)
            this.widget.self = {
                baseline: { type: this.searchBoxCond.type, sTi: "", eTi: "" },
                compare: { type: this.searchBoxCond.type, sTi: "", eTi: "" },
            };
        if (!this.widget.chart)
            this.widget.chart = {
                colorOpens: false,
                backgroundColor: "#ffffff",
                gridColor: "#0000001F",
                fontColor: "#000000",
                chartFontSize: 14,
                titleFontSize: 14,
                series: [],
                options: {},
            };

        // 각 시리즈에 unit과 displayUnit이 없으면 초기화
        if (this.widget.chart.series) {
            this.widget.chart.series.forEach((series) => {
                if (!series.unit) {
                    this.$set(series, "unit", "");
                }
                if (series.displayUnit === undefined) {
                    this.$set(series, "displayUnit", null);
                }
            });
        }
    },
    mounted() {
        let horizontals = document.getElementsByClassName("xeHorizontalBar");
        for (let i = 0; i < horizontals.length; i++) {
            horizontals[i].parentNode.style.height = "100%";
        }
    },
    methods: {
        goToNext() {
            if (this.$refs.carousel) {
                this.$refs.carousel.next();
            }
        },
        goToPrev() {
            if (this.$refs.carousel) {
                this.$refs.carousel.prev();
            }
        },
        initSetting() {
            this.setTheme();
        },
        setTheme() {
            // this.$el.style.backgroundColor = this.themeColor.chart.horizontal.backgroundColor || "transparent";
        },
        defaultLabels() {
            return this.widget.chart.series.map((item) => global.xe.$t(item.label));
        },
        defaultDatasets() {
            return this.widget.chart.series.map((item) => ({
                backgroundColor: item.dataColor,
                borderColor: item.dataColor,
                fill: false,
                label: global.xe.$t(item.label),
                yAxisID: "Left_yAxis",
                point: item.point,
            }));
        },
        applyData(widgetLogs) {
            try {
                let datasets = this.defaultDatasets();
                let datas = [];
                let backgroundColors = [];

                let copyLogs = JSON.parse(JSON.stringify(widgetLogs));
                copyLogs = utils.onAfterAction2(datasets, copyLogs, this.widget.addition.afterAction);

                datasets.forEach((dataset) => {
                    let ptVals = copyLogs[0].points[dataset.point] || 0;
                    ptVals = this.isEmpty(ptVals) ? 0 : ptVals.sum();
                    let ptVal = utils.fixedValue(ptVals, this.widget.addition.fixed);
                    datas.push(ptVal);
                    backgroundColors.push(dataset.backgroundColor);
                });

                const labels = this.defaultLabels();
                // 정렬 전에 원본 인덱스와 시리즈 정보를 저장
                const combined = labels.map((label, i) => {
                    const series = this.widget?.chart?.series?.[i];
                    return {
                        divCdName: label,
                        currentConsumpt: datas[i],
                        prevConsumpt: 0,
                        lastConsumpt: 0,
                        divCd: `item_${i}`,
                        originalIndex: i, // 원본 인덱스 저장
                        seriesIndex: i, // 시리즈 인덱스 저장
                        backgroundColor: backgroundColors[i], // 색상 미리 저장
                        series: series, // 시리즈 정보 미리 저장
                    };
                });

                // 정렬
                combined.sort((a, b) => b.currentConsumpt - a.currentConsumpt);

                // 각 시리즈별 단위 변환 처리 (원본 인덱스 사용)
                combined.forEach((item) => {
                    const series = item.series;
                    if (!series) return;

                    const originalUnit = series.unit || "";
                    const displayUnit = series.displayUnit || originalUnit || "";
                    const shouldConvert = displayUnit &&
                        displayUnit !== originalUnit &&
                        originalUnit &&
                        displayUnit !== "";

                    // 원본 값 저장 (변환 전에 항상 저장)
                    item.originalCurrentConsumpt = item.currentConsumpt;
                    item.originalPrevConsumpt = item.prevConsumpt;
                    item.originalLastConsumpt = item.lastConsumpt;

                    // 단위 변환이 필요한 경우 변환 수행
                    if (shouldConvert) {
                        if (item.currentConsumpt != null) {
                            item.currentConsumpt = this.convertUnit(item.currentConsumpt, originalUnit, displayUnit);
                        }
                        if (item.prevConsumpt != null) {
                            item.prevConsumpt = this.convertUnit(item.prevConsumpt, originalUnit, displayUnit);
                        }
                        if (item.lastConsumpt != null) {
                            item.lastConsumpt = this.convertUnit(item.lastConsumpt, originalUnit, displayUnit);
                        }
                    }

                    // displayUnit 저장
                    item.displayUnit = displayUnit;
                    item.originalUnit = originalUnit;
                });

                this.progressData = combined;
                // 색상 매핑 (원본 인덱스 기반)
                this.itemColors = {};
                combined.forEach((item) => {
                    this.itemColors[item.divCd] = item.backgroundColor;
                });

                this.widgetLogs = widgetLogs;
            } catch (err) {
                console.error(`${this.$options.name} applyData`, err);
            }
        },
        handleDropPoint(transfer) {
            let that = this;
            function append(points) {
                points.map((point) => {
                    if (that.widget.series.filter((v) => v.point === point.ptAddr).length == 0) {
                        that.widget.series.push({
                            label: point.title,
                            point: point.ptAddr,
                            position: "Left",
                            backgroundColor: that.getRandomColor(),
                        });
                    }
                });
            }

            let defaultObj = { label: "Default", point: "", position: "Left", backgroundColor: "#348fe2" };
            if (JSON.stringify(this.widget.chart.series.slice(0, 1)) == JSON.stringify([defaultObj]))
                this.widget.chart.series = [];
            append(transfer.item.type === this.CODE.Drag.PointGroup ? transfer.item.points : [transfer.item]);
        },
        convertUnit(value, fromUnit, toUnit) {
            // value가 0이거나 null/undefined인 경우 처리
            if (value == null || value === undefined || isNaN(value)) {
                return value;
            }

            // 단위가 없거나 같은 경우 변환 불필요
            if (!fromUnit || !toUnit || fromUnit === toUnit) {
                return value;
            }

            try {
                // 먼저 정방향 변환 시도 (Unit.convert 사용)
                let converted = Unit.convert(value, fromUnit, toUnit);

                // 변환 결과가 원래 값과 같으면 (변환 실패) 역방향 변환 시도
                if (converted === value) {
                    const fromType = Unit.typeIs(fromUnit);
                    const toType = Unit.typeIs(toUnit);

                    // 역방향 변환 규칙 찾기
                    if (
                        fromType &&
                        toType &&
                        Unit.conversion &&
                        Unit.conversion[toType] &&
                        Unit.conversion[toType][fromType]
                    ) {
                        const reverseConv = Unit.conversion[toType][fromType];

                        // Unit.convert의 내부 로직을 따라 역방향 변환 수행
                        // 1. fromUnit을 reverseConv.to로 변환 (같은 타입 내)
                        const step1 = Unit.kilometer(
                            value,
                            Unit.types[fromType][fromUnit],
                            Unit.types[fromType][reverseConv.to]
                        );

                        // 2. 역계수 적용 (1 / base)
                        const step2 = step1 * (1 / reverseConv.base);

                        // 3. reverseConv.unit을 toUnit으로 변환 (같은 타입 내)
                        converted = Unit.kilometer(
                            step2,
                            Unit.types[toType][reverseConv.unit],
                            Unit.types[toType][toUnit]
                        );
                    } else {
                        // 역방향 변환 규칙도 없으면 원래 값 반환
                        console.warn("No conversion rule found (both directions)", {
                            fromUnit,
                            toUnit,
                            fromType,
                            toType,
                        });
                        return value;
                    }
                }

                // 변환 결과가 유효한 숫자인지 확인
                if (converted != null && !isNaN(converted) && isFinite(converted)) {
                    return converted;
                }
                return value;
            } catch (err) {
                console.warn("Unit conversion failed:", err, { value, fromUnit, toUnit });
                return value;
            }
        },
    },
};
</script>

<style scoped>
.heightImportant {
    height: calc(100% - 40px);
}

.xeHorizontalBar.is-overview-compact .heightImportant {
    height: calc(100% - 28px);
}

.align-card-content {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
    height: 100%;
}

.xeHorizontalBar.is-overview-compact .align-card-content {
    padding: 0 8px;
}

.progress-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    justify-content: center;
}

.progress-slide {
    height: 100%;
    /* display: flex;
    align-items: center;
    justify-content: center; */
}

.horizontal-carousel {
    width: 100%;
    height: 100%;
}

.right-controls {
    display: flex;
    align-items: center;
    gap: 10px;
}

.rounded-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.right-controls-usage {
    display: flex;
    align-items: center;
    gap: 10px;
}

.xeHorizontalBar.is-overview-compact .right-controls-usage {
    gap: 4px;
}

.arrow {
    font-size: 16px !important;
}

.xeHorizontalBar.is-overview-compact .arrow {
    font-size: 14px !important;
}

.arrow:hover {
    color: grey;
    cursor: pointer;
}
</style>
